import {
    useCallback, useEffect, useState,
} from 'react'
import isEqual from 'lodash/isEqual'
import DomainObjectForm from 'app/shared-components/DomainObjectForm'

import QuoteInformationForm from '../QuoteInformationForm'
import {
    AQuote,
} from '../AQuotes.types'
import useAQuoteInformationContext from '../AQuoteCreate/AQuoteInformationContext'

export default function AQuoteInformation({
    data,
    disabled,
    getActionButtons,
}: Readonly<{
    data: AQuote,
    disabled: boolean,
    getActionButtons?: (
        options?: {
            onNext?: () => void,
            disabled?: boolean,
            isValid?: boolean,
            value?: AQuote
        }) => JSX.Element[]
}>) {
    const {
        activeStep,
        setActiveStep,
        setValue,
        setIsEdited,
    } = useAQuoteInformationContext()

    const [
        formValues,
        setFormValues,
    ] = useState<AQuote>(data)

    const nextAction = useCallback(() => {
        setValue(formValues)
        setActiveStep(activeStep + 1)
    }, [
        formValues,
        setValue,
        setActiveStep,
        activeStep,
    ])

    useEffect(() => {
        if (!isEqual(data, formValues)) {
            setIsEdited(true)
        }
    }, [
        setIsEdited,
        formValues,
        data,
    ])

    return (
        <QuoteInformationForm
            disabled={disabled}
            value={formValues}
            setValue={setFormValues}
            omitField={[
                'customerQuotation',
                'pricingResponsible',
                'plannedContractBasis',
                'skyCellContact',
            ]}
            render={({
                fields, formData, onChange, isValid,
            }) => {
                return (
                    <div key="QuoteInformationForm">
                        <DomainObjectForm
                            name="AQuoteInformation"
                            value={formData}
                            fields={fields}
                            onChange={onChange}
                            disabled={disabled}
                        />
                        {getActionButtons?.({
                            value: formValues,
                            onNext: nextAction,
                            disabled,
                            isValid,
                        }) || []}
                    </div>
                )
            }}
        />
    )
}
